import React from "react";
import { Button } from "./ui/button";
import { Rocket, Target, RefreshCw, Copy } from "lucide-react";
import { toast } from "sonner";
import { AcquisitionSummary } from "./plan/AcquisitionSummary";
import { WebScanCard } from "./plan/WebScanCard";
import { ActionPlanBody } from "./plan/ActionPlanBody";

export { probColor } from "../lib/constants";

const planToText = (p, acq, plan) => [
  `PIANO D'AZIONE — ${p.azienda}`, `Probabilità acquisizione: ${acq.probability}%`, "",
  `Leva: ${plan.leva_principale}`, `Hook: ${plan.hook_apertura}`, "",
  "Perché noi:", ...(plan.perche_noi || []).map((x) => `- ${x}`), "",
  "Argomenti:", ...(plan.argomenti || []).map((a) => `- ${a.titolo}: ${a.testo}`), "",
  "Obiezioni:", ...(plan.obiezioni || []).map((o) => `- ${o.obiezione} → ${o.risposta}`), "",
  `Offerta: ${plan.offerta_consigliata?.servizio} · ${plan.offerta_consigliata?.pacchetto} · ${plan.offerta_consigliata?.prezzo_indicativo} · ${plan.offerta_consigliata?.durata}`,
  `Primo passo: ${plan.primo_passo}`,
].join("\n");

export const ActionPlanTab = ({ p, running, onRunEngine, onRegenPlan, regen }) => {
  const acq = p.acquisition || {};
  const plan = p.action_plan || {};
  const hasAcq = acq.probability != null;
  const hasPlan = !!plan.leva_principale;

  const copyPlan = () => {
    navigator.clipboard.writeText(planToText(p, acq, plan));
    toast.success("Piano copiato");
  };

  return (
    <div className="space-y-4" data-testid="plan-tab">
      <div className="flex items-center justify-between gap-2">
        <p className="text-xs text-muted-foreground">Sito, social, Google Adv e andamento → priorità, % acquisizione e piano AI.</p>
        <Button size="sm" onClick={onRunEngine} disabled={running} data-testid="run-engine-btn">
          <Rocket className={`mr-2 h-3.5 w-3.5 ${running ? "animate-pulse" : ""}`} />
          {running ? "Elaboro..." : hasAcq ? "Ri-esegui analisi completa" : "Analisi completa"}
        </Button>
      </div>

      {!hasAcq && !running && (
        <div className="rounded-xl border border-dashed border-border p-6 text-center text-sm text-muted-foreground" data-testid="plan-empty">
          Premi <b>Analisi completa</b>: il motore visita il sito, legge Instagram, calcola la probabilità di acquisizione e genera il piano per convincerlo a scegliere 20/80LAB.
        </div>
      )}

      {hasAcq && (
        <>
          <AcquisitionSummary acq={acq} />
          <WebScanCard scan={p.web_scan} />
          {acq.steps && (
            <div className="flex flex-wrap gap-x-4 gap-y-1 text-[0.65rem] text-muted-foreground" data-testid="engine-steps">
              {Object.entries(acq.steps).map(([k, v]) => <span key={k}><b className="capitalize">{k.replace("_", " ")}</b>: {v}</span>)}
            </div>
          )}
          <div className="flex items-center justify-between border-t border-border pt-4">
            <span className="flex items-center gap-2 label-caps text-primary"><Target className="h-3.5 w-3.5" /> Piano d'azione AI</span>
            <div className="flex gap-1.5">
              {hasPlan && <Button size="sm" variant="ghost" onClick={copyPlan} data-testid="copy-plan-btn"><Copy className="mr-1.5 h-3.5 w-3.5" /> Copia</Button>}
              <Button size="sm" variant="outline" onClick={onRegenPlan} disabled={regen || running} data-testid="regen-plan-btn">
                <RefreshCw className={`mr-1.5 h-3.5 w-3.5 ${regen ? "animate-spin" : ""}`} /> {hasPlan ? "Rigenera piano" : "Genera piano"}
              </Button>
            </div>
          </div>
        </>
      )}

      {hasPlan && <ActionPlanBody plan={plan} />}
    </div>
  );
};
